"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("./Button.styles");
const props = {
  /**
   * Alters the underlying html tag
   */
  as: _propTypes.default.string,
  /**
   * If `true`, the button will render as an anchor.
   */
  asAnchor: _propTypes.default.bool,
  /**
   * If `true`, and an anchor button, target="_blank" and rel="noopener noreferrer" will be set on the anchor
   * "isExternal" is used to maintain parity with the Link component.
   */
  isExternal: _propTypes.default.bool,
  /**
   * If `true`, the button will show a spinner.
   */
  isLoading: _propTypes.default.bool,
  /**
   * If `true`, the button will be styled in its active state.
   */
  isActive: _propTypes.default.bool,
  /**
   * If `true`, the button will be disabled.
   */
  isDisabled: _propTypes.default.bool,
  /**
   * The label to show in the button when `isLoading` is true
   * If no text is passed, it only shows the spinner
   */
  loadingText: _propTypes.default.string,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  isFullWidth: _propTypes.default.bool,
  /**
   * The html button type to use.
   */
  type: _propTypes.default.oneOf(['button', 'reset', 'submit']),
  /**
   * If added, the button will show an icon before the button's label.
   * @type PropTypes.node
   */
  leftIcon: _propTypes.default.node,
  /**
   * If added, the button will show an icon after the button's label.
   * @type PropTypes.node
   */
  rightIcon: _propTypes.default.node,
  /**
   * The space between the button icon and label.
   * @type SystemProps["marginRight"]
   */
  iconSpacing: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  /**
   * Replace the spinner component when `isLoading` is set to `true`
   * @type PropTypes.node
   */
  spinner: _propTypes.default.node,
  variant: _propTypes.default.oneOf(Object.keys(_Button.variants))
};
var _default = exports.default = props;